/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import type { Address, Path } from '@ahm/api-wrappers-core';
import type { ContextModalProps } from '@mantine/modals';
import FormPath from '@/features/booking/components/paths/form-path';

type ModalPathProps = Pick<
  ContextModalProps<{
    path?: Path;
    onConfirm: (path: Path) => void;
    selectedAddress?: Address;
    pathIndex: number;
  }>,
  'innerProps'
> & {
  onClose?: () => void;
};

export default function ModalPath({ innerProps }: ModalPathProps) {
  const { pathIndex, path, onConfirm, selectedAddress } = innerProps;

  return (
    <FormPath
      pathIndex={pathIndex}
      path={path}
      onConfirm={onConfirm}
      selectedAddress={selectedAddress}
    />
  );
}
